export default {
  "failed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Failed to log out"])}
}